import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import {
  KpiMaster,
  KpisMastersInput,
  PlayerCompetitionKpi,
  PlayerCompetitionKpisInput,
  PlayerGameKpi,
  PlayerGameKpisInput,
  PlayerRoleKpi,
  PlayerRoleKpisInput,
  TeamGameKpiInput,
} from '@/core/models/kpi.interface';
import {
  KPI_MASTER_QUERY,
  PLAYER_COMPETITION_KPI_QUERY,
  PLAYER_GAME_KPI_QUERY,
  PLAYER_ROLE_KPI_QUERY,
  TEAM_GAME_KPIS,
} from '@/core/services/queries/kpi.graphql';
import { TeamGameKpi } from '@/features/pre-game/interfaces/team-data.interface';

@Injectable({
  providedIn: 'root',
})
export class KPIService {
  private readonly apollo = inject(Apollo);

  getKpisMasters(filter: KpisMastersInput): Observable<KpiMaster[]> {
    return this.apollo
      .watchQuery<{ kpisMasters: KpiMaster[] }>({
        query: KPI_MASTER_QUERY,
        variables: {
          filter,
        },
      })
      .valueChanges.pipe(map((result) => result.data.kpisMasters));
  }

  getPlayerGameKpis(filter: PlayerGameKpisInput): Observable<PlayerGameKpi[]> {
    return this.apollo
      .watchQuery<{ playerGameKpis: PlayerGameKpi[] }>({
        query: PLAYER_GAME_KPI_QUERY,
        variables: {
          filter,
        },
      })
      .valueChanges.pipe(map((r) => r.data.playerGameKpis));
  }

  getPlayerCompetitionKpis(filter: PlayerCompetitionKpisInput): Observable<PlayerCompetitionKpi[]> {
    return this.apollo
      .watchQuery<{ playerCompetitionKpis: PlayerCompetitionKpi[] }>({
        query: PLAYER_COMPETITION_KPI_QUERY,
        variables: {
          filter,
        },
      })
      .valueChanges.pipe(map((r) => r.data.playerCompetitionKpis));
  }

  getPlayerRoleKpis(filter: PlayerRoleKpisInput): Observable<PlayerRoleKpi[]> {
    return this.apollo
      .watchQuery<{ playerRoleKpis: PlayerRoleKpi[] }>({
        query: PLAYER_ROLE_KPI_QUERY,
        variables: { filter },
      })
      .valueChanges.pipe(map((r) => r.data.playerRoleKpis));
  }

  getTeamGameKpis(filter: TeamGameKpiInput): Observable<TeamGameKpi[]> {
    return this.apollo
      .watchQuery<{ teamGameKpis: TeamGameKpi[] }>({
        query: TEAM_GAME_KPIS,
        variables: { filter },
      })
      .valueChanges.pipe(map((r) => r.data.teamGameKpis));
  }
}
